/** Guard submit and wizard-next handlers, including forms with noValidate. */
export function configurationDraftIsValid(scope: ParentNode = document): boolean {
  const invalid = scope.querySelector<HTMLElement>('[data-license-configuration][data-invalid="true"]');
  if (!invalid) return true;
  // The summary stays visible even when an invalid field is in a closed accordion.
  invalid.querySelector<HTMLElement>('[role="alert"]')?.focus();
  return false;
}
